import { Http, Moment, Url } from '@intelipost-js/secure-providers';

export default {
  generateFreightCostReport(context, requestParams) {
    const {
      report_type = '',
      dateRange = {
        start: Moment(),
        end: Moment().subtract(1, 'days'),
      },
      logistic_provider_id = 0,
      weight_ranges = 10,
      origin_zip_codes = [],
      sales_channel = '',
    } = requestParams;

    const pathParams = [
      report_type,
      dateRange.start,
      dateRange.end,
    ];

    const filter = {
      logistic_provider_id,
      origin_zip_codes,
      sales_channel,
    };

    if (report_type === 'weight') {
      Object.assign(filter, { weight_ranges });
    }
    context.commit('setLoading', true);
    return Http.get(Url.toQueryString(
      'api/v1/report/freight_cost/excel',
      filter,
      pathParams,
    ))
      .then((res) => {
        context.commit('setLoading', false);
        context.commit('setHasGeneratedReport', true);
        Promise.resolve(res);
      })
      .catch((err) => {
        context.commit('setLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/freight-cost/store/actions.js